import {ReactElement} from "react";
import {PD_LG, PD_XLG, PD_XLG3} from "@/shared/dimens";
import {StyledBoxColumn, StyledBoxRow, StyledHeadingVariant} from "@/shared/StyledComponents";
import {LargeButton} from "./SharedComponents";
import {useMediaQuery, useTheme} from "@mui/material";
import {HeroSectionData, SiteTemplate} from "../../types";

export function HeroSection(props: { data: HeroSectionData, template: SiteTemplate }): ReactElement {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  return <div style={{
    width: "100%",
    position: "relative",
    aspectRatio: md ? 16 / 7 : sm ? 16 / 9 : 4 / 3,
    overflow: "hidden",
  }}>
    <img
      src={props.data.imageUrl}
      style={{
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        objectFit: "cover",
        objectPosition: "center top",
      }}/>
    <div style={{
      position: "absolute",
      inset: 0,
      background: "linear-gradient(135deg, rgba(200,0,120,0.82) 0%, rgba(80,0,160,0.6) 40%, rgba(0,200,255,0.45) 75%, transparent 100%)",
    }}/>
    <div style={{
      position: "absolute",
      inset: 0,
      display: "flex",
      alignItems: "center",
    }}>
      <StyledBoxColumn style={{
        width: md ? "48%" : "90%",
        padding: md ? `0 ${PD_XLG3}px` : `0 ${PD_LG}px`,
        gap: PD_XLG,
      }}>
        <StyledHeadingVariant default_={1} style={{color: "white", lineHeight: 1.05}}>
          {props.data.title}
        </StyledHeadingVariant>
        <StyledBoxRow style={{gap: PD_LG, flexWrap: "wrap"}}>
          {props.data.primaryLink?.text
            ? <LargeButton
              href={props.data.primaryLink.url}
              variant={"contained"}
              color={"secondary"}>
              {props.data.primaryLink.text}
            </LargeButton>
            : null}
          {props.data.secondaryLink?.text
            ? <LargeButton
              href={props.data.secondaryLink.url}
              variant={"outlined"}
              style={{color: "white", borderColor: "rgba(255,255,255,0.6)"}}>
              {props.data.secondaryLink.text}
            </LargeButton>
            : null}
        </StyledBoxRow>
      </StyledBoxColumn>
    </div>
  </div>;
}
